// extracted by mini-css-extract-plugin
module.exports = {"topbar":"style_topbar__3O9OO","logo":"style_logo__2aSKt"};